import React from "react";
import { InputMascara } from "./InputMascara";


export type InputCpfProps = {
    cpf:string,
    onCpfModificado: (cpf:string) => void
    emitirComMascara?: boolean
}

export const InputCpf = (props: InputCpfProps) => <InputMascara 
    mascara="999.999.999-99"
    emitirComMascara={props.emitirComMascara === undefined || props.emitirComMascara === true}
    onValorModificado={props.onCpfModificado}
    inputMode="numeric"
    type="tel"
    valor={props.cpf}/>